import jsonpatch from 'fast-json-patch';
import { get, post, put } from './api';

// TODO: type this — Vuex module context and dynamic collection state
/* eslint-disable @typescript-eslint/no-explicit-any */
type Ctx = any;
type CollectionState = Record<string, any>;
/* eslint-enable @typescript-eslint/no-explicit-any */

function getCollection(state: CollectionState, collection: string) {
    if (Object.prototype.hasOwnProperty.call(state, collection)) {
        return state[collection];
    }
    return [];
}

function getItem(state: CollectionState, collection: string, id: string) {
    const c = getCollection(state, collection);
    if (Object.prototype.hasOwnProperty.call(c, id)) {
        return c[id];
    }
    return null;
}

const UserCollectionStore = {
    namespaced: true,
    state: {} as CollectionState,
    getters: {
        getItem: (state: CollectionState) => (collection: string, id: string) => {
            return getItem(state, collection, id);
        },
        getCollection: (state: CollectionState) => (collection: string) => {
            return getCollection(state, collection);
        },
    },
    mutations: {
        patch(state: CollectionState, { collection, id, patch }: Ctx): void {
            const item = getItem(state, collection, id);
            jsonpatch.applyPatch(item, patch);
            if (patch.some((p: Ctx) => p.op === 'add')) {
                delete state[collection][id];
                state[collection][id] = item;
            }
        },
        add(state: CollectionState, { collection, item }: Ctx): void {
            if (!Object.prototype.hasOwnProperty.call(state, collection)) {
                state[collection] = {};
            }
            state[collection][item._id] = item;
        },
        remove(state: CollectionState, { collection, id }: Ctx): void {
            if (Object.prototype.hasOwnProperty.call(state, collection)) {
                delete state[collection][id];
            }
        },
    },
    actions: {
        async update({ commit }: Ctx, { collection, id, patch }: Ctx): Promise<unknown> {
            const results = await put(collection, id, patch);
            commit('patch', { collection, id, patch });
            return results;
        },
        async add({ commit }: Ctx, { collection, item }: Ctx): Promise<unknown> {
            const results = await post(collection, item);
            commit('add', { collection, item });
            return results;
        },
        async load({ commit }: Ctx, { collection }: Ctx): Promise<unknown> {
            const results = (await get(collection)) as Record<string, unknown>;
            for (const i in results) {
                commit('add', { collection, item: results[i] });
            }
            return results;
        },
    },
};

export default UserCollectionStore;
